import { RowCreateButton, ActionColumn, EditableDatagrid } from "@airborne/react-admin";
import React from "react";
import { BooleanField, TextField, TextInput, TopToolbar } from "react-admin";
import CustomerUserEditForm from "./CustomerUserEditForm";
import CustomerUserCreateForm from "./CustomerUserCreateForm";
import CustomerUserCreateFormEmptyModal from "./CustomerUserCreateFormEmptyModal";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";

const CustomerUserList = props => {
  const CustomerUserListActions = () => (
    <TopToolbar>
      <RowCreateButton />
    </TopToolbar>
  );

  const CustomerUserListFilters = [
    <TextInput label="Register Id" source="registerId__contains" variant="outlined" helperText={false} alwaysOn />,
    <TextInput label="Owner Code" source="ownerCode__contains" variant="outlined" helperText={false} alwaysOn />,
  ];

  return (
    <PoolList
      title="Customer Users"
      bulkActionButtons={false}
      actions={<CustomerUserListActions />}
      filters={CustomerUserListFilters}
      exporter={false}
      style={{ width: "100%" }}
      empty={<CustomerUserCreateFormEmptyModal />}
      {...props}
    >
      <EditableDatagrid createForm={<CustomerUserCreateForm />} editForm={<CustomerUserEditForm />}>
        <TextField source="registerId" label="Register Id" />
        <TextField source="ownerCode" label="Owner Code" />
        <BooleanField source="isEditable" label="Is Editable" />
        <ActionColumn />
      </EditableDatagrid>
    </PoolList>
  );
};

export default CustomerUserList;
